import { useQuery } from '@common/hooks';
import { SCHEDULE_GROUP_TEAM_FILTERS_QUERY } from '@load-balancing/graphql/queries/schedule-group-team-filters';

export function useSkillCoverageEnabled(scheduleGroupId?: string): boolean {
  const { data } = useQuery(SCHEDULE_GROUP_TEAM_FILTERS_QUERY, {
    variables: { scheduleGroupId: scheduleGroupId ?? '' },
    skip: !scheduleGroupId,
  });

  return data?.scheduleGroupTeamFilters?.skillCoverageEnabled ?? false;
}
